import { render, staticRenderFns } from "./SelectAmbience.vue?vue&type=template&id=dc38196c"
import script from "./SelectAmbience.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectAmbience.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc38196c')) {
      api.createRecord('dc38196c', component.options)
    } else {
      api.reload('dc38196c', component.options)
    }
    module.hot.accept("./SelectAmbience.vue?vue&type=template&id=dc38196c", function () {
      api.rerender('dc38196c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/ambience/ambience/components/SelectAmbience.vue"
export default component.exports